export const siteStats = [
  { id: 'st-1', value: '12,800+', label: '收录剧集条目', sub: '覆盖长短剧与单元剧' },
  { id: 'st-2', value: '9,400+', label: '电影条目', sub: '含剧情、文艺与商业片' },
  { id: 'st-3', value: '26 类', label: '类型标签', sub: '可按兴趣快速筛选' },
  { id: 'st-4', value: '4 档', label: '清晰度片源', sub: '标清至高 4K 说明' },
];